var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldRefreshSquare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm-.59 5.23A6.718 6.718 0 0 1 12 5.25c1.8 0 3.5.7 4.77 1.98.03.03.06.07.09.11v-.86c0-.41.34-.75.75-.75s.75.34.75.75v2.65c0 .41-.34.75-.75.75h-2.65c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.83c-.03-.03-.05-.06-.08-.09A5.22 5.22 0 0 0 12 6.75c-1.4 0-2.72.55-3.71 1.54-.97.97-1.51 2.26-1.53 3.63a.76.76 0 0 1-.76.73h-.01c-.41 0-.74-.35-.74-.76.03-1.76.73-3.42 1.97-4.66zM12 18.75c-1.8 0-3.5-.7-4.77-1.98-.03-.03-.06-.07-.09-.11v.85c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.65c0-.41.34-.75.75-.75h2.65c.41 0 .75.34.75.75s-.34.75-.75.75h-.83c.03.03.05.06.08.09A5.22 5.22 0 0 0 12 17.24c1.4 0 2.72-.55 3.71-1.54.98-.98 1.53-2.29 1.53-3.69 0-.41.34-.75.75-.75s.75.34.75.75c0 1.81-.7 3.5-1.97 4.76A6.719 6.719 0 0 1 12 18.75z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldRefreshSquare2);
export default __webpack_public_path__ + "static/media/vuesax-bold-refresh-square-2.488de4a9164e2ddb2b5c21e6f1a94204.svg";
export { ForwardRef as ReactComponent };